import React from 'react'

import { Box } from '@mui/material'
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const ACTIVE_COLOR = "var(--c-accent)";

const SidebarButton = ({ icon, text, active, onClick }) => {
  return (
    <ListItem disablePadding sx={{ mb: 0.25 }}>
      <ListItemButton
        onClick={onClick}
        selected={active}
        aria-current={active ? "page" : undefined}
        sx={{
          position: "relative",
          minHeight: 40,
          px: 1.5,
          borderRadius: "10px",
          color: "var(--c-text-3)",
          transition: "background-color 120ms ease, color 120ms ease",
          "&:hover": { backgroundColor: "var(--c-muted)", color: "var(--c-text)" },
          "&.Mui-selected": {
            backgroundColor: "var(--c-accent-bg)",
            color: ACTIVE_COLOR,
          },
          "&.Mui-selected:hover": { backgroundColor: "var(--c-accent-bg-strong)" },
        }}
      >
        {/* Accent bar on the active item */}
        {active && (
          <Box sx={{
            position: "absolute",
            left: -12,
            top: 8,
            bottom: 8,
            width: 3,
            borderRadius: "0 3px 3px 0",
            backgroundColor: ACTIVE_COLOR,
          }} />
        )}
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: 1.5,
            color: "inherit",
            "& svg": { fontSize: 20 },
          }}
        >
          {icon}
        </ListItemIcon>
        <ListItemText
          primary={text}
          slotProps={{
            primary: { sx: { fontSize: 14, fontWeight: active ? 600 : 500 } },
          }}
        />
      </ListItemButton>
    </ListItem>
  )
}

export default SidebarButton
